import AccountFeesDataTableHandler from '@Modules/cardManagementSystem/cardholder/containers/dataTableHandler/accountDetail/fees/AccountFeesDataTableHandler'

const InsuranceFeesPage = () => {
  return (
    <><AccountFeesDataTableHandler tab='insurance'/></>
  )
}

export default InsuranceFeesPage